import React from 'react'
import styled from 'styled-components'
import { Text } from 'toonswap-uikit'
import { useWeb3React } from '@web3-react/core'

export interface StakedProps {
  value: number
  decimals: number
}

const StakedWrapper = styled.div`
  min-width: 80px;
  font-size: 18px;
  color: #ffffff97;
  text-align: left;
`

const Staked: React.FC<StakedProps> = ({ value }) => {
  const { account } = useWeb3React()
  const displayValue =
    account && value !== null && value !== undefined
      ? value.toLocaleString(undefined, { maximumFractionDigits: 4 })
      : '?'

  return (
    <StakedWrapper>
      <Text color="#ffffff97">{displayValue}</Text>
    </StakedWrapper>
  )
}

export default Staked
